//
// Copyright © 2024 Hardcore Engineering Inc.
//

import { print, printId } from './plugin'

export * from './utils'

export { printId }

export default print
